/**
 * Created by piotr.pozniak@thebeaverhead.com on 06/01/2019.
 */

import React, { useContext, useEffect, useState } from "react";

import PropTypes from "prop-types";
import { CalendarHeader as MonthlyCalendarHeader } from "./CalendarHeader";
import CalendarHeader from "../CalendarHeader";
import classnames from "classnames";
import CalendarDay from "./CalendarDay";
import Events from "../EventsList/Events";
import EventsListModal from "../EventsList/EventsListModal";
import { CT, PT } from "../../../../consts";
import PoweredBy from "../PoweredBy";
import SearchInput from "../AiSearch/SearchInput";
import useAiSearch from "../../../../hooks/useAiSearch";
import WidgetSettingsContext from "../../../../contexts/WidgetSettingsContext";
import CalendarLinkingContext from "../../../../contexts/CalendarLinkingContext";
import { getEndOfMonth, getStartOfMonth } from "../../../../helpers/date";

const MonthlyView = (props) => {
  const widgetSettings = useContext(WidgetSettingsContext);
  const linking = useContext(CalendarLinkingContext);

  const [state, setState] = useState({
    selectedDay: props.selectedDate,

    showDayEventsInModal:
      props.selectedEvent || linking.selectedEvent ? true : false,
  });

  useEffect(() => {
    setState({
      ...state,
      selectedDay: props.selectedDate,
    });
  }, [props.selectedDate]);

  const { calendar, events } = props;

  const calendarID = "dce_calendar__" + calendar.model.uuid;
  const loading =
    calendar.rsvp || calendar.fetch || calendar.delete || calendar.update;
  const { hasAIEnabled } = useAiSearch(calendar.model.integration);

  const hideNavigation =
    Number.parseInt(widgetSettings["mcHideEventsList"]) === 1;
  const showEventsCountTooltip =
    Number.parseInt(widgetSettings["mcShowEventsCounter"]) === 1;
  const showFullNamesTooltip =
    Number.parseInt(widgetSettings["mcShowEventsDetailedInfo"]) === 1;
  const showPills = Number.parseInt(widgetSettings["mcShowEventsNames"]) === 1;
  const pillOpensEventDetails =
    Number.parseInt(widgetSettings["mcShowNamesShowsDetails"]) === 1;
  const isCompact = Number.parseInt(widgetSettings["mcCompactView"]) === 1;
  const useEventAccent =
    Number.parseInt(widgetSettings["generalUseEventAccent"]) === 1;

  // first day of the week set by the user (0 - 6, 0 - Sunday)
  const firstDayOfWeek = widgetSettings["firstDayOfWeek"];

  // current month first day, to know what day of the week is it (1 - 7, 1 - Sunday)
  const firstDayOfMonth = getStartOfMonth(props.selectedDate).getISODay();
  // to know how many days are in the month (1 - 31)
  const lastDayOfMonth = getEndOfMonth(props.selectedDate).getDate();

  const recurringShowBadge =
    Number.parseInt(widgetSettings["recurringShowBadge"]) === 1;
  const featuredShowBadge =
    Number.parseInt(widgetSettings["featuredShowBadge"]) === 1;
  const isEventsLimited =
    Number.parseInt(widgetSettings["isEventsLimited"]) === 1;
  const limitedNumberOfEvents = Number.parseInt(
    widgetSettings["limitedNumberOfEvents"]
  );

  /**
   *
   * @param day
   */
  const onSelectDay = (day) => () => {
    const data = { selectedDay: day };

    if (pillOpensEventDetails) {
      data.showDayEventsInModal = true;
    }

    setState(data);
  };

  /**
   *
   * @param date
   */
  const onDateChange = (month) => {
    // setState({ selectedDay: state.selectedDay.add(month, "month") });

    props.onSelectedDateChange(month);
  };

  /**
   *
   */
  const onCloseEventsListModal = () => {
    setState({ ...state, showDayEventsInModal: false });
  };

  let workingDate = getStartOfMonth(props.selectedDate);

  const daysInWeek = 7;
  const firstWeekOffset =
    (daysInWeek - (firstDayOfWeek - firstDayOfMonth)) % daysInWeek;
  // how many rows in the calendar will be. Usually it's 5 rows but sometimes, depending
  // on the first day of the month, may be that month's weeks applies to 6 yearly weeks
  const weeksInMonth = Math.ceil(
    (firstWeekOffset + lastDayOfMonth) / daysInWeek
  );

  const watermark =
    calendar.model && calendar.model.is_watermarked ? <PoweredBy /> : null;

  const eventsContainer = (
    <div
      className={classnames({
        "rev--loader-monthly-row-item": events.fetch || !props.initialized,
      })}
    >
      <table className={classnames("", { compact: isCompact })}>
        <MonthlyCalendarHeader
          isCompact={isCompact}
          firstDayOfWeek={firstDayOfWeek}
        />

        <tbody>
          {[...Array(weeksInMonth).keys()].map((i, idx) => {
            return (
              <tr key={"week-" + idx}>
                {[...Array(7).keys()].map((j, jdx) => {
                  const dayIdx = idx * 7 + jdx; // + firstDayOfWeek;
                  const day = dayIdx - firstDayOfMonth;

                  if (
                    dayIdx < firstWeekOffset ||
                    dayIdx >= lastDayOfMonth + firstWeekOffset
                  ) {
                    return (
                      <td
                        key={"day-" + day}
                        className={classnames("", {
                          day: day <= lastDayOfMonth,
                        })}
                      />
                    );
                  }

                  const momentDay = new Date(
                    workingDate
                  ); /*.utcOffset(0, true)*/
                  workingDate = workingDate.addDays(1);

                  return (
                    <CalendarDay
                      key={"day-" + day}
                      day={momentDay}
                      events={events}
                      embedded={props.embedded}
                      onSelectDay={onSelectDay}
                      selectedDay={state.selectedDay}
                      showPills={showPills}
                      isCompact={isCompact}
                      showEventsCountTooltip={showEventsCountTooltip}
                      showFullNamesTooltip={showFullNamesTooltip}
                      pillOpensEventDetails={pillOpensEventDetails}
                      useEventAccent={useEventAccent}
                      showRecurring={recurringShowBadge}
                      showFeatured={featuredShowBadge}
                      isEventsLimited={isEventsLimited}
                      limitedNumberOfEvents={limitedNumberOfEvents}
                    />
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );

  const selectedDayEvents =
    linking.selectedEvent && events.collection.length === 1
      ? [linking.selectedEvent]
      : events.collection.filter((e) => {
          return state.selectedDay.isBetween(
            new Date(e.start_time * 1000) /*.utc()*/,
            new Date(e.end_time * 1000) /*.utc()*/,
            "day"
          );
        });

  const eventsList =
    !hideNavigation && !events.fetch ? (
      <Events
        events={selectedDayEvents}
        calendarSlug={calendar.model.slug}
        embedded={props.embedded}
        loading={loading}
        error={props.calendar.rsvpError}
        onLoadMore={props.onLoadMore}
        hasMore={events.collection.length !== events.totalRows}
        calendarID={calendarID}
        selectedEvent={linking.selectedEvent}
      />
    ) : null;

  const selectedDayEventsList =
    state.showDayEventsInModal && selectedDayEvents.length ? (
      <EventsListModal
        calendar={props.calendar}
        events={selectedDayEvents}
        embedded={props.embedded}
        closeOpenedEventsDetails={onCloseEventsListModal}
        loading={loading}
        error={props.calendar.rsvpError}
        currentDate={state.selectedDay}
        selectedEvent={linking.selectedEvent}
      />
    ) : null;

  const search =
    hasAIEnabled && widgetSettings["aiEnabled"] ? (
      <SearchInput
        searchEvents={props.searchEvents}
        fetchEvents={props.fetchEvents}
      />
    ) : null;

  return (
    <div className={classnames(`full-calendar dce--${CT.monthly}`)}>
      <CalendarHeader
        disabled={events.fetch}
        calendar={calendar}
        currentDate={props.selectedDate}
        onChangeDate={onDateChange}
        events={events.collection}
        locations={events.locations}
        onUpcomingNavigationChange={props.onUpcomingNavigationChange}
        selectedFilters={props.selectedFilters}
        onChangeFilter={props.onChangeFilter}
        onSearch={props.onKeywordSearch}
      />
      {search}

      {selectedDayEventsList}
      {eventsContainer}
      {watermark}
      {eventsList}
    </div>
  );
};

MonthlyView.propTypes = {
  calendar: PropTypes.object,
  events: PropTypes.object,
  onSelectedDateChange: PropTypes.func.isRequired,
  onUpcomingNavigationChange: PropTypes.func.isRequired,
  selectedDate: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  initialized: PropTypes.bool,
  onLoadMore: PropTypes.func.isRequired,
  previewType: PropTypes.oneOf(Object.values(PT)),
  onChangeFilter: PropTypes.func.isRequired,
  selectedFilters: PropTypes.object.isRequired,
  searchEvents: PropTypes.func.isRequired,
  fetchEvents: PropTypes.func.isRequired,
  onKeywordSearch: PropTypes.func.isRequired,
  singleEventSlug: PropTypes.string,
  selectedEvent: PropTypes.object,
};

export default MonthlyView;
